import { render, staticRenderFns } from "./AddBlockModal.vue?vue&type=template&id=58a6ccb3&"
import script from "./AddBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockModal.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports